import { useState } from "react";
import { toast } from "sonner";
import { Button, Input } from "@/components/ui";

export const ContactPage = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("Thanks! We'll get back to you soon.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="mx-auto max-w-md">
      <h1 className="mb-8 text-3xl font-bold text-foreground">Contact Us</h1>
      <form onSubmit={handleSubmit}>
        <Input
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <Input
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <div className="mb-4">
          <label htmlFor="message" className="mb-2 block text-foreground">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
            required
            className="w-full rounded-md border border-input bg-background p-2 text-foreground focus:border-ring focus:ring-1 focus:ring-ring"
          />
        </div>
        <Button type="submit">Send Message</Button>
      </form>
    </div>
  );
};

export default ContactPage;
